import React, { Component } from 'react'
import { Radio, Spin } from 'hljd'
import { observer, inject } from 'mobx-react'
import styles from './style.module.less'
import NoticeList from './NoticeList'
import MainNoticeList from './NoticeList/MainIndex'
import Page from './Page'
import { isSiDaTeam } from '@util'

const RadioGroup = Radio.Group
const RadioButton = Radio.Button

@inject('store')
@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getNoticeList(1)
  }

  render() {
    const {
      unreadObj,
      selectTab,
      readStatus,
      isLoading,
      noticeList,
      onChangeStatus,
      readNotice
    } = this.props.store
    let unreadNum = unreadObj[selectTab] ? Number(unreadObj[selectTab]) : 0
    return (
      <div
        className={styles.contentWrap}
        style={{ minHeight: document.body.clientHeight - 157 }}
      >
        <div className={styles.header}>
          <RadioGroup size="large" value={readStatus} onChange={onChangeStatus}>
            <RadioButton value="">全部</RadioButton>
            <RadioButton value="0">
              未读{unreadNum > 99 ? '99+' : unreadNum > 0 ? unreadNum : ''}
            </RadioButton>
          </RadioGroup>
          <span className={styles.allReaded} onClick={readNotice}>
            全部已读
          </span>
        </div>

        {isSiDaTeam() ? <MainNoticeList /> : <NoticeList />}

        {noticeList.length > 0 && <Page />}
        {isLoading && <Spin size="large" className="center" />}
      </div>
    )
  }
}
